import { render, staticRenderFns } from "./fokteven.vue?vue&type=template&id=885418fa"
import script from "./fokteven.vue?vue&type=script&lang=js"
export * from "./fokteven.vue?vue&type=script&lang=js"
import style0 from "./fokteven.vue?vue&type=style&index=0&id=885418fa&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports